import {
  BasketPatchItem,
  ExtendedDtoBasket,
} from '@epicuro-next/data/baskets-dto';
import { createAction, props } from '@ngrx/store';
import { Basket } from 'graphql-api/baskets-api-interfaces';
import { Account } from 'graphql-api/gql-api-interfaces';
import { BasketNotification } from '@epicuro-next/models/basket';
import { BasketUpdateShops } from '../../models';

/**
 * Triggers a basket load from GQL
 */
export const loadBasketById = createAction('[Basket] Load Basket By Id');
export const loadActiveBasket = createAction('[Basket] Load Active basket');
export const loadOpenedBasket = createAction(
  '[Basket] Load Opened basket',
  props<{ basketId: string }>(),
);

/**
 * Dispatched on sucessfull basket load
 */
export const loadBasketSuccess = createAction(
  '[Basket] Load Basket Success',
  props<{ basketData: Basket }>(),
);

export const setBasketLoading = createAction(
  '[Basket] Set loading',
  props<{ value: boolean }>(),
);
/**
 * Dispatched on failed basket load
 */
export const loadBasketFailure = createAction(
  '[Basket] Load Basket Failure',
  props<{ error: string }>(),
);

/**
 * Dispatched on failed active basket load
 */
export const loadActiveBasketFailure = createAction(
  '[Basket] Load Active Basket Failure',
  props<{ error: string }>(),
);
/**
 * Action for updating the basket order reference number
 */
export const updateReferenceNumber = createAction(
  '[Basket] Update Order Reference Number',
  props<{ referenceNumber: string }>(),
);
/*
 * Update the basket items for the currently selected account / address
 */
export const updateBasketItems = createAction(
  '[Basket] Update Basket Items',
  props<BasketUpdateShops>(),
);
/**
 * Updating quantities/delivery success
 */
export const updateBasketItemsSuccess = createAction(
  '[Basket] Update Basket Items Success',
);
/**
 * Updating quantities/delivery dates of given basket items
 */
export const updateBasketItemsFailure = createAction(
  '[Basket] Update Basket Items Failure',
  props<{ error: string }>(),
);

/**
 * Updating basket shops
 */
export const updateBasketShops = createAction(
  '[Basket] Update Basket Shops',
  props<{ accounts: Account[] }>(),
);

/**
 * Updating basket shops
 */
export const updateBasketShopsSuccess = createAction(
  '[Basket] Update Basket Shops Success',
  props<{ basketId: string }>(),
);

/**
 * Updating basket shops
 */
export const updateBasketShopsFail = createAction(
  '[Basket] Update Basket Shops Fail',
  props<{ error: string }>(),
);

/*
 * Update the basket notification value
 */
export const writeItemsInsertOrUpdate = createAction(
  '[Basket] Write Updated Variants',
  props<{ items: BasketPatchItem[] }>(),
);

/*
 * Update the basket notification value
 */
export const setBasketNotification = createAction(
  '[Basket] Show Basket Notification',
  props<BasketNotification>(),
);

export const pollBasket = createAction('[Basket] Poll basket');

/*
 * Clear the basket notification value
 */
export const clearBasketNotification = createAction(
  '[Basket] Clear Basket Notification',
);

/*
 * Rescheduling delivery
 */
export const rescheduleBasketItem = createAction(
  '[Basket] Reschedule Delivery For Basket Item',
);

/* DTO Basket */
export const loadDtoBasketById = createAction('[Basket] Load Dto Basket By Id');

export const loadDtoBasketSuccess = createAction(
  '[Basket] Load DTO Basket Success',
  props<{ basket: ExtendedDtoBasket }>(),
);

export const loadDtoBasketFailure = createAction(
  '[Basket] Load DTO Basket Failure',
  props<{ error?: string }>(),
);

export const updateDtoBasketSuccess = createAction(
  '[Basket] Update DTO Basket Success',
);

export const updateDtoBasketFailure = createAction(
  '[Basket] Update DTO Basket Failure',
  props<{ error?: string }>(),
);
